import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  modalInsideStack: {
    width: 1450,
    height: 800,
  },
  messageBarStyle: { width: 330 },
  stickyInsideStack: {
    alignItems: 'self-start',
    padding: 25,
  },
  stack: {
    padding: 25,
  },
  documentTypeDropdown: {
    width: 250,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  dropdownWrapper: {
    width: 500,
  },
  disabledText: {
    color: `${theme.palette.neutralTertiary}${theme.isInverted ? '55' : ''}`,
  },
  columnHeight: {
    height: 25,
  },
}));
